(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dad-gift-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
 const money = new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP',minimumFractionDigits:0,maximumFractionDigits:2});
 function refresh(section, focus) {
  const selected=section.querySelector('input[name="dad-gift-amount"]:checked');
  const custom=section.querySelector('[data-gift-custom]');
  const input=section.querySelector('[data-gift-input]');
  const error=section.querySelector('[data-gift-error]');
  const output=section.querySelector('[data-gift-value]');
  const isCustom=selected?.value==='custom';
  custom.hidden=!isCustom;
  input.disabled=!isCustom;
  if(!isCustom){error.hidden=true;input.removeAttribute('aria-invalid');output.textContent=money.format(Number(selected?.value || 25));return;}
  if(focus) input.focus();
  const raw=input.value.trim();
  const valid=/^\d+(\.\d{1,2})?$/.test(raw)&&Number(raw)>0&&Number.isSafeInteger(Math.round(Number(raw)*100));
  output.textContent=valid?(Number.isInteger(Number(raw))?money.format(Number(raw)):new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(raw))):'£—';
  input.setAttribute('aria-invalid',String(!valid&&raw.length>0));
  error.hidden=valid||raw.length===0;
 }
 document.addEventListener('change',event=>{
  if(event.target.matches('input[name="dad-gift-amount"]'))refresh(event.target.closest('.dad-gift-section'),true);
 });
 document.addEventListener('input',event=>{
  if(event.target.matches('[data-gift-input]'))refresh(event.target.closest('.dad-gift-section'),false);
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["still-header"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.stillPreviewReady) return;
  window.stillPreviewReady = true;
  let opener = null;
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-dad-sort]')) return;
    const grid = event.target.closest('section').querySelector('.ss-grid');
    const cards = Array.from(grid.children);
    cards.sort((a,b) => event.target.value === 'low' ? Number(a.dataset.price)-Number(b.dataset.price) : event.target.value === 'high' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.order)-Number(b.dataset.order));
    cards.forEach(card => grid.appendChild(card));
  });
  const openDialog = (id, source) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.tagName !== 'DIALOG') return false;
    document.querySelectorAll('.ss-dialog[open]').forEach(d => d.close());
    if (source && !source.closest('dialog')) opener = source;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.scrollTop = 0;
    dialog.querySelector('.ss-close')?.focus();
    return true;
  };
  const closeDialog = dialog => {
    dialog.close();
    document.body.style.overflow = '';
    if (location.hash === '#' + dialog.id) history.replaceState(null, '', location.pathname + location.search);
    opener?.focus();
  };
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href^="#"]');
    if (anchor && openDialog(anchor.hash.slice(1), anchor)) {
      event.preventDefault();
      history.replaceState(null, '', anchor.hash);
    }
    const close = event.target.closest('[data-ss-close]');
    if (close) closeDialog(close.closest('dialog'));
    const expand = event.target.closest('[data-ss-expand]');
    if (expand) {
      const gallery = expand.closest('.ss-product-gallery');
      const expanded = gallery.dataset.expanded !== 'true';
      gallery.dataset.expanded = String(expanded);
      expand.setAttribute('aria-expanded', String(expanded));
      expand.textContent = expanded ? expand.dataset.collapseLabel : expand.dataset.expandLabel;
    }
    if (anchor?.closest('.ss-mobile-menu')) anchor.closest('details').open = false;
    const menu = document.querySelector('.ss-mobile-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menu = document.querySelector('.ss-mobile-menu[open]');
      if (menu) {menu.open = false; menu.querySelector('summary').focus();}
    }
  });
  document.addEventListener('cancel', event => {
    if (event.target.matches('.ss-dialog')) {event.preventDefault();closeDialog(event.target);}
  }, true);
  window.addEventListener('hashchange', () => openDialog(location.hash.slice(1)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => openDialog(location.hash.slice(1)));
  else openDialog(location.hash.slice(1));
})();


  } catch(e) { console.error(e); }
})();
})();
